exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".APIDocumentationPage__code___2npb0 {\n  background-color: #eff0f1;\n  margin-bottom: 1em;\n  padding: 5px;\n  max-height: 600px;\n  overflow: auto;\n}\n.APIDocumentationPage__spancode___ymF-K {\n  background-color: #eff0f1;\n}\n.APIDocumentationPage__endpointSection___3ZGZZ {\n  padding-top: 50px;\n}\n.APIDocumentationPage__access___1vGM6 {\n  color: #949494;\n}\n", ""]);
// Exports
exports.locals = {
	"code": "APIDocumentationPage__code___2npb0",
	"spancode": "APIDocumentationPage__spancode___ymF-K",
	"endpointSection": "APIDocumentationPage__endpointSection___3ZGZZ",
	"access": "APIDocumentationPage__access___1vGM6"
};